import formMapper from '../utils/formMapper';
import { note } from '../validations';

export default (NAME) =>
	formMapper(NAME, {
		note: {
			validations: note,
			required: true,
			requiredMessage: 'customRequired',
		},
	});
